import { render, staticRenderFns } from "./inspectionAdd.vue?vue&type=template&id=9b9ee2f2&scoped=true&"
import script from "./inspectionAdd.vue?vue&type=script&lang=js&"
export * from "./inspectionAdd.vue?vue&type=script&lang=js&"
import style0 from "./inspectionAdd.vue?vue&type=style&index=0&id=9b9ee2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9ee2f2",
  null
  
)

export default component.exports